// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TIzmk{list-style:disc;list-style-position:inside;padding-top:24px;line-height:1.2}.rmaQe{padding-top:16px}.NnhYm{padding:0px 24px 8px 24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"includedServices": `TIzmk`,
	"includedServiceTitle": `rmaQe`,
	"includedServiceDescription": `NnhYm`
};
export default ___CSS_LOADER_EXPORT___;
